import { openBackUrl } from 'Util/openBackUrl'
import Button from 'components/base/Button'
import { TranslationContext } from 'contexts/TranslationContext'
import React, { useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import { TASK_STATUS } from '~/enums'
import './vrspot.scss'

export default function ProfileLink({ status }) {
  const user = useSelector(state => state.user)
  const handleBackToAccount = useCallback(() => {
    openBackUrl(user)
  }, [ user ])
  const { t } = useContext(TranslationContext)

  return (
    <If condition={status === TASK_STATUS.COMPLETED}>
      <div className="save-settings__text">
        <p>{t('SAVE_SETTINGS_TEXT_VIDEO_SUBMITTED_TO_YOUR_ACCOUNT')}</p>
      </div>
      <div className="render-result-vrspot__btn-back-to-account" title={t('SAVE_SETTINGS_BTN_BACK_TO_MY_ACC_TOOLTIP')}>
        <Button onClick={handleBackToAccount} data-lang-id="SAVE_SETTINGS_BTN_BACK_TO_MY_ACC" border>{t('SAVE_SETTINGS_BTN_BACK_TO_MY_ACC')}</Button>
      </div>
    </If>
  )
}
